// Labels need to be propagated as this is a common component shared between usc/build.
import type { TyreType } from "../../common-deprecated/types/CommonTypes";

export type TyreInfoLabels = {
    tyreInfo: string;
    tyreInfoNoEprelFallback: string;
    tyreInfoDescription: string | null;
    tyreInfoFallbackDescription: string;
    tyreInfoFallback: string;
};
/**
 * These Modals have the same functionality. The detailed info has more tyre info. Splitting this up to hopefully align them soon to one modal
 * USC does not yet have all the data for the detailed view but this will most likely come soon.
 */
export const MODAL_TYRE_INFO = "tyreInfo";
export const MODAL_DETAILED_TYRE_INFO = "DetailedTyreLabelInfo";
export type TyreInfoModalType = {
    type: typeof MODAL_TYRE_INFO;
    tyres: string[];
    tyreInfoLabels: TyreInfoLabels;
};
export type DetailedTyreInfoModalType = {
    type: typeof MODAL_DETAILED_TYRE_INFO;
    tyres: TyreType[];
    tyreInfoLabels: TyreInfoLabels;
};
